import AppConstants from '../constants/app-constants';
import type { LanguageType } from '../types/language';

const LanguageEnglish : LanguageType = {
    // ID must match database
    id: 1,
    name: 'english',
    short: 'EN',
    flag: 'https://moes.beer/images/languages/english.svg',

    modes: [
        { id: AppConstants.GAMEMODE_STANDARD, name: "Standard", description: "Everyone participates with their own device" },
        { id: AppConstants.GAMEMODE_SPEAKER, name: "Speaker", description: "You will be the host that leads your party to drunkeness" },
    ],
    
    categories: [
        { id: AppConstants.CATEGORY_SPILL_BEANS, name: "Spill your beans", description: "In this category a randomly chosen player will get a question. What they pick will be the correct answer - how well do you know the other people at the party?" },
        { id: AppConstants.CATEGORY_PICK_SIDE, name: "Pick a side", description: "Be invisible or able to fly? Pineapple on a pizza, yey or nay? Here you pick a side and the side with the most picks wins - the other side drinks!" },
        { id: AppConstants.CATEGORY_MOST_LIKELY, name: "Most likely", description: "Who's most likely to break up with someone over text message? Who's most likely to puke tonight? Up to five randomly chosen as options, time to become f(r)iends." },
        { id: AppConstants.CATEGORY_RANDOM_QUESTIONS, name: "Random questions", description: "Is it illegal to kill Santa Clause in Canada? Is crossword puzzle a younger invention than airplanes? In this category, random knowledge is the key to winning." },
    ],
    
    icons: [
        { name: "", description: "" },
        { name: "Verified", description: "Logged in" },
        { name: "Winner", description: "Last rounds winner" },
        { name: "Loser", description: "Last rounds loser" },
    ],

    // Index
    index: {
        title: "The classic <drinking> <games> gathered online",

        intro: [
            "What movie describes your sex life?",
            "Who is most likely to answer the phone in the middle of sex?",
            "These are the kind of questions you will have to face when playing moes Beer.",
        ],

        // Not used
        outro: [
            "Moes.beer is a free online game where each participant connects with their mobile to answer questions.",
            "For optimal experience the questions should be streamed to a TV,",
            "either through the SmartTV's web browser or a computer connected to it.",
            "Otherwise, there is support to only play through mobiles."
        ],

        create: "Create Game",
        join: "Join Lobby",
        
        socialMedia: "Follow us on social media!",
    },

    common: {
        enterName: "Enter your first name",
        name: "Name",
    },
    
    // Ongoing games
    ongoing: {
        ongoing: "Ongoing Game(s)",
        info: "",
    },

    fullscreen: {
        question: "Do you want to play in fullscreen?",
        yes: "Yes",
        no: "No"
    },

    // Auth
    auth: {
        signIn: "Sign in to your account",
        register: "Register an account",
        
        email: "E-mail address",
        password: "Password",
        passwordsDontMatch: "Passwords don't match",
        registeredSuccessfully: "You have successfully registered and can now login with your account!",
        
        preferredNickname: "Preferred Nickname",

        stats: "Stats",
        gamesHosted: "Games hosted",
        gamesPlayed: "Games played",
        gamesWon: "Games won",
        gamesLost: "Games lost",
        totalScore: "Total score",
        averageScore: "Average score",
        
        // Buttons
        buttonRegister: "Register",
        buttonLogin: "Login",
        buttonUpdate: "Update information",
        buttonLogout: "Logout",
    },
    
    // Create
    create: {
        back: "Back",
        next: "Next",
        gameMode: "Choose your game mode",
        gameModeStandard: "Standard",
        createStandard: "Create a Standard game",
        gameModeSpeaker: "Speaker",
        createSpeaker: "Create a Speaker game",
        selectMode: "Please select a mode for more information",
        deviceFor: "This device is for",
        hosting: "Displaying questions (TV)",
        playing: "Answering questions (Phone)",
        yourName: "Your name",
        questionsLanguage: "Language on Questions",
        categories: "Game categories",
        createLobby: "Create Lobby",
        
        createError: "Create Error",
        invalidGameMode: "Invalid Game Mode",

        modesInfo: {
            1: [
                "Everyone needs to join on their own device.",
                "They will use their device to answer the questions.",
                " ",
                "Pick this one if you plan on showing the questions on a TV (Smart-TVs web-browser or computer plugged to it), or play yourself."
            ],
            2: [
                "No-one will be able to join this lobby.",
                "You will need to read questions out loud.",
                " ",
                "Pick this one if you wanna play a game of most likely or pick a side.",
            ]
        }
    },

    /* Join */
    join: {
        back: "Back",
        yourName: "Name",
        lobbyCode: "Code",
        enterLobbyCode: "Enter lobby code",
        joinLobby: "Join Lobby",
    },

    /* Help */
    help: {
        back: "Back",
        header: "Help",
        howItLooks: "How It Looks",
        categories: "Categories",
        aboutUs: "About Us",
        otherInfo: "Other Information",

        helpContent: [
            "What movie describes your sexlife? Who is most likely to answer the phone in the middle of sex?",
            "These are the kind of questions you will have to face when playing moes Beer.",
        ],
        aboutUsContent: [
            "Many of the questions are community made.",
            "We do not take any responsible for where or from whom our users found the questions.",
            "We do our best to screen all of the questions and reject, or modify, those containing strong language.",
            "We can not be held responsible for the questions added by our community.",
            "Got a question or game question, feedback, an idea or are you just angry? Contact us by sending an email to support@moes.beer."
        ],
        categoriesContent: {
            "1": ["In this category a randomly chosen player will get a question.", "What they pick will be the correct answer - how well do you know the other people at the party?"],
            "2": ["Is it illegal to kill Santa Clause in Canada? Is crossword puzzle a younger invention than air planes?", "In this category, random knowledge is the key to winning."],
            "4": ["Be invisible or able to fly? Pineapple on a pizza, yey or nay?", "Here you pick a side, and the side with the most picks wins - the other side drinks!"],
            "5": ["Who's most likely to break up with someone over text message? Who's most likely to puke tonight?", "Up to four randomly chosen as options, time to become f(r)iends."]
        },
        otherInfoContent: [
            "Cookies",
            "We use cookies on our website to improve your experience.",
            "Moes.Beer uses third-party cookies in the form of analytics cookies and advertising cookies. Through this we get to know you a little better by collecting information about how you as a user interact with our website.",
            "If you do not want to accept cookies, you can setup your browser so that the cookie files are not downloaded to your device.",
            " ",
            "Facebook Pixel",
            "We use the Facebook pixel. This is to be able to show ads on Facebook that suit you a little better, provided you are a Facebook user and have given Facebook permission to do so.",
            "If you do not wish to give Facebook permission for this, you can remove your approval via your Facebook account",
        ],
    },

    // Speaker mode
    speaker: {
        noQuestionsFound: "No questions found. Refreshing the page sadly terminates the lobby.",
        options: "This question has the following options:",
        personLeftOfYou: "person left of you",
        showAnswer: "Show answer",
        back: "Back",
        next: "Next",
        create: "Create a new game",
        roundFinished: "Round finished! If you want to play again, create a new speaker lobby.",
        tips: [
            "Tip: On questions with true/false, it's smart to let people raise their hand if they vote for true.",
            "Also: pressing BACK on your phone/tablet/browser will send you to the first menu and cancel this game. Please use the buttons.",
        ],
    },

    // Lobby
    lobby: {
        teamHeader: "Lobby",
        joinAtOrQRCode: "Join at moes.beer or scan the QR code",
        waitingOnConnection: "Waiting for connection towards the game server...",
        waitingOnServer: "Waiting on server to verify access to this lobby.",
        failedToConnect: "Failed to connect to game server. Please refresh to try again",
        noCookie: "You are not in this lobby. Please rejoin it.",
        lobbyCode: "Game Code",
        leaveLobby: "Leave Lobby",
        invalidGameState: "Invalid game state detected.",

        players: "%p Players",
        start: "Start game",

        gameInfoHeader: "Game Settings",
        iconsHeader: "Icons",
        categoriesHeader: "Categories",
        
        /* Starting */
        starting: {
            gameStarting: "Game is starting!",
            tips: [
                "One correct answer equals one point",
                "Decide on how many chugs each wrong answer is!"
            ]
        },

        /* Question page */
        question: {
            pressTimerToHide: "Press here to hide the question",
            pressTimerToShow: "Press here to show the question",
        },

        /* Drink */
        drink: {
            correctAnswer: "Correct Answer",
            draw: "Draw",
            yatzy: "YATZY! Everyone picked the same side - everyone drinks!",
            missingOption: "Missing Option/No Answer",
            afk: "AFK/No answer",
            none: "None",

            showVotes: "Show Votes",
            hideVotes: "Hide Votes",

            answerCorrect: "You were CORRECT!",
            answerIncorrect: "You guessed WRONG!",

            ready: "Ready",
            isReady: "You are ready",
            readyStatus: "%c players ready",
            questionsDone: "Question %q out of %t done"
        },

        advertise: {
            advertisement: "Advertisement",
        },
        
        /* Done */
        done: {
            followUs: "Follow us for a free beer!",
            theWinnerIs: "The winner is...",
            thanksForPlaying: "Thanks for playing moes.Beer!",
            leaderboard: "Leaderboard",
            rank: "Rank",
            nickname: "Name",
            score: "Score",
            leaveLobby: "Leave",
            playAgain: "Play Again",
            playAgainWaiting: "Waiting on Admin",
        },
    },

    /* Server status */
    serverStatus: {
        idle: "Unable to connect. Please refresh this window to try again.",
        connecting: "Connecting...",
        offline: "Unable to connect. Trying to reconnect.",
        unknown: "Unknown server error. Please refresh this window.",
        disconnected: "You have been disconnected from the server: %e",
    },

    // Errors
    errors: {
        [AppConstants.ERR_NONE]: "",
        [AppConstants.ERR_PARAMETER_INVALID]: "Invalid parameters",
        [AppConstants.ERR_BACKEND_OFFLINE]: "Backend appears to be offline",

        [AppConstants.ERR_LOBBY_INVALID]: "Invalid lobby",
        [AppConstants.ERR_LOBBY_NOT_ADMIN]: "You're not the host",
        [AppConstants.ERR_LOBBY_ALREADY_PLAYING]: "You are already in a lobby",
        [AppConstants.ERR_LOBBY_MORE_PLAYERS]: "Not enough players",
        [AppConstants.ERR_LOBBY_STATE]: "Lobby is in invalid state",
        [AppConstants.ERR_LOBBY_KICKED]: "You have been kicked",
        [AppConstants.ERR_LOBBY_STARTED]: "Lobby has already started",

        [AppConstants.ERR_CREATE_DEVICE]: "Missing device",
        [AppConstants.ERR_CREATE_MODE]: "Invalid game mode",
        [AppConstants.ERR_CREATE_FAILED]: "Failed to create game. Check your settings.",

        [AppConstants.ERR_NICKNAME_LENGTH]: "Nickname too long",
        [AppConstants.ERR_NICKNAME_TAKEN]: "Nickname already taken",
        [AppConstants.ERR_NICKNAME_INVALID]: "Nickname invalid (only a-z allowed)",

        [AppConstants.ERR_PLAYER_NULL]: "You are not authenticated",
        [AppConstants.ERR_PLAYER_LOBBY]: "You have not joined a lobby",
        [AppConstants.ERR_PLAYER_READY_ALREADY]: "Player already ready",
        [AppConstants.ERR_PLAYER_HOST]: "You are the host",

        [AppConstants.ERR_COOKIE_INVALID]: "No cookie found for this lobby",

        [AppConstants.ERR_ANSWER_INVALID]: "Invalid answer",
        [AppConstants.ERR_ANSWER_ALREADY]: "You can't answer right now",

        [AppConstants.ERR_DISCONNECT_NEW_CLIENT]: "Newer connection found, make sure you only have one tab open",
        
        [AppConstants.ERR_MISSING_PARAMETERS]: "Missing parameters",
        [AppConstants.ERR_PASSWORDS_DONT_MATCH]: "Passwords don't match",
        [AppConstants.ERR_INVALID_EMAIL]: "Invalid email address",
        [AppConstants.ERR_EMAIL_EXISTS]: "Email already exists",
        [AppConstants.ERR_UNABLE_TO_CREATE]: "Unable to create account",

        [AppConstants.ERR_INCORRECT_CREDENTIALS]: "Incorrect credentials",
    }
};

export default LanguageEnglish;